import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get } from 'vuex-pathify';
export default {
  name: 'TeamMemberTableNumberEntry',
  components: {
    FibBackButton: require('@/components/BackButton').default
  },
  data: function data() {
    return {
      error: '',
      loading: false,
      tableNumber: ''
    };
  },
  computed: {
    eposData: get('checkIn/eposData'),
    digitalReceiptAvailable: get('checkIn/digitalReceiptAvailable'),
    hasConnectivity: get('settings/hasConnectivity'),
    isDisabled: function isDisabled() {
      return !((this.tableNumber || this.tableNumber === 0) && this.tableNumber >= 0 && this.isNumber(this.tableNumber));
    }
  },
  methods: {
    noNumber: function noNumber() {
      this.$store.commit('checkIn/resetState');
      this.$router.push('/check_in/get_started');
    },
    backToStaff: function backToStaff() {
      this.$router.push('/staff');
    },
    isNumber: function isNumber(val) {
      return typeof val === 'number';
    },
    onSubmit: function onSubmit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _this.error = '';

                _this.$store.commit('checkIn/tableNumber', _this.tableNumber);

                if (_this.hasConnectivity) {
                  _context.next = 6;
                  break;
                }

                _this.$router.push('/check_in/get_started');

                return _context.abrupt("return");

              case 6:
                _context.next = 8;
                return _this.$store.dispatch('checkIn/fetchTransactionData', true);

              case 8:
                res = _context.sent;

                if (!(res || {}).error) {
                  _context.next = 13;
                  break;
                }

                _this.loading = false;
                _this.error = res.error;
                return _context.abrupt("return");

              case 13:
                if (_this.eposData) {
                  _context.next = 17;
                  break;
                }

                Logger.debug('epos data NOT available, redirecting to get started');

                _this.$router.push('/check_in/get_started');

                return _context.abrupt("return");

              case 17:
                Logger.debug('epos data available'); // check if digital receipt available

                if (!_this.digitalReceiptAvailable) {
                  _context.next = 24;
                  break;
                }

                // digital receipt available, redirect to digital receipt and return
                Logger.debug('digital receipt available, redirecting to digital receipt');

                _this.$router.push('/check_in/digital_receipt');

                return _context.abrupt("return");

              case 24:
                // digital receipt NOT available, redirect to get started and return
                Logger.debug('digital receipt NOT available, redirecting to get started');

                _this.$router.push('/check_in/get_started');

                return _context.abrupt("return");

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};